import React from 'react';
import { Button } from '@/components/ui/button';
import { useDebug } from '@/hooks/useDebug';
import { Bug } from 'lucide-react';
import { DebugPanel } from './DebugPanel';

export function DebugLauncher() {
  const { debugEnabled, isOpen, setIsOpen } = useDebug();
  if (!debugEnabled) return null;

  return (
    <>
      <div className="fixed bottom-5 right-5 z-50">
        <Button variant="outline" size="icon" aria-label="Open debug panel" onClick={() => setIsOpen(true)}>
          <Bug className="h-5 w-5" />
        </Button>
      </div>
      <DebugPanel />
    </>
  );
}
